export default "__VITE_ASSET__BIlU2a9C__"